<div class="policy-actions margin-bottom-xmedium flex" [ngClass]="{'flex-justify-space-evenly': actionList.length > 2}">
  <div *ngFor="let item of actionList" class="policy-actions-container">
    <button mat-flat-button color="primary" (click)="handleAction(item.action, item.type)" class="width-100">
      <div class="flex flex-items-center">
        <open-svg-icon [name]="item.icon" class="xsmall white"></open-svg-icon>
        <span class="policy-actions-button-label">{{ item.label }}</span>
      </div>
    </button>
  </div>
</div>
